import axios from "./axios";

/**
 * @param {number|string} projectId
 * @param {object} [options] axios config — use `params` for query (e.g. selectable_for_work_order, work_order_id)
 * @returns {Promise<Array>} project activity rows
 */
export async function fetchProjectActivities(projectId, options = {}) {
  if (!projectId) return [];
  const response = await axios.get(`/projects/${projectId}/project_activities`, options);
  const payload = response.data;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload)) return payload;
  return [];
}

/**
 * Create a project activity on a project (optionally link as activity_source later via work order save).
 * @param {number|string} projectId
 * @param {object} attributes — title (required), description, number, etc.
 */
export async function createProjectActivity(projectId, attributes) {
  if (!projectId) throw new Error("projectId required");
  const response = await axios.post(`/projects/${projectId}/project_activities`, {
    project_activity: attributes,
  });
  const payload = response.data;
  return payload?.data ?? payload;
}
